import React, { useState } from 'react'
import { Link } from 'react-router-dom'

// styles
import './KaiwaList.css'

// metadata
import { TopicMetadata } from '../metadata/TopicMetadata'

// convert segment to value for sorting purposes 
// e.g 5-1 -> 501 
const segmentToValue = (segment) => (parseInt(segment.split('-')[0]) * 100 + parseInt(segment.split('-')[1]))

export default function KaiwaList({ data }) {
    const [selectedKaiwa, setSelectedKaiwa] = useState('1')
    // TODO: Grab all of this from a metadata structure 
    // (the google sheet -> turned into json in python -> uploaded to firestore) -> query that here

    // e.g. 5-1, 5-2, 5-3 ...
    let uniqueKaiwaSegments = Array.from(new Set(data.map((d) => d.kaiwa_segment)))

    // hard coded as this will never change
    let uniqueKaiwa = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']

    // generate kaiwa to segment map {'1': ['1-1','1-2'...], ...}
    let kaiwaMap = {}
    for (let k of uniqueKaiwa) {
        kaiwaMap[k] = []
        for (let s of uniqueKaiwaSegments) {
            if (s.split('-')[0] === k) {
                kaiwaMap[k].push(s)
            }
        }
        kaiwaMap[k].sort((a, b) => segmentToValue(a) - segmentToValue[b])
    }
    return (
        <div className='main-kaiwa-list-box container'>
            <hr className='divider'/>
            <div className='row'>
                <div className="d-flex flex-column flex-shrink-0 col-auto p-1" style={{ width: "120px" }}>
                    <ul className="nav nav-pills flex-column mb-auto">
                        {Object.keys(kaiwaMap).map((kaiwa) => (
                            <li
                                key={kaiwa}
                                className={selectedKaiwa === kaiwa ? 'kaken-item nav-item mb-1 bg-secondary text-white' : 'kaken-item nav-item mb-1'}
                                onClick={() => setSelectedKaiwa(kaiwa)}
                            >
                                科研　{kaiwa}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className='col-1'></div>
                <div className='kaiwa-list-box col-auto pt-0 pr-2'>
                    <div className='container'>
                        <div className='row vstack'>
                            {
                            kaiwaMap[selectedKaiwa].map((seg) => (
                                <Link key={seg} to={`/kaiwa/${seg}`} style={{ textDecoration: 'none' }}><span className='seg-link'>{seg} </span>{TopicMetadata[seg]}</Link>
                                
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
